import { render, staticRenderFns } from "./exhibit-content-modal.vue?vue&type=template&id=20ccdc43&scoped=true&"
import script from "./exhibit-content-modal.vue?vue&type=script&lang=js&"
export * from "./exhibit-content-modal.vue?vue&type=script&lang=js&"
import style0 from "./exhibit-content-modal.vue?vue&type=style&index=0&id=20ccdc43&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ccdc43",
  null
  
)

export default component.exports